// Classic Hilbert curve, generated procedurally. Order n gives a 2^n x 2^n
// grid visited once each; consecutive points are unit steps.
import type { CurveGeometry } from '../types.ts';

function d2xy(N: number, d: number, out: Int32Array): void {
  let x = 0, y = 0, t = d;
  for (let s = 1; s < N; s <<= 1) {
    const rx = (t >> 1) & 1;
    const ry = (t ^ rx) & 1;
    if (ry === 0) {
      if (rx === 1) { x = s - 1 - x; y = s - 1 - y; }
      const tmp = x; x = y; y = tmp;
    }
    x += s * rx;
    y += s * ry;
    t >>= 2;
  }
  out[0] = x; out[1] = y;
}

export function buildHilbert(order: number): CurveGeometry {
  order = Math.max(1, Math.min(14, order | 0));
  const N = 1 << order;
  const nPts = N * N;
  const half = N / 2;
  const coords = new Float32Array(nPts * 2);
  const xy = new Int32Array(2);
  for (let d = 0, j = 0; d < nPts; d++) {
    d2xy(N, d, xy);
    coords[j++] = xy[0] + 0.5 - half;
    coords[j++] = xy[1] + 0.5 - half;
  }
  return {
    dims: 2,
    nPoints: nPts,
    closed: false,
    bbox: { min: [-half + 0.5, -half + 0.5, 0], max: [half - 0.5, half - 0.5, 0] },
    coords,
  };
}
